import Buat from "../pages/buat/Buat";
import Bursa from "../pages/bursa/Bursa";
import DaftarKuisioner from "../pages/daftar-kuisioner/DaftarKuisioner";
import DetailKuesioner from "../pages/daftar-kuisioner/DetailKuesioner";
import Edit from "../pages/edit/Edit";
import HasilKuesioner from "../pages/hasil-kuis/HasilKuesioner";
import HasilKuis from "../pages/hasil-kuis/HasilKuis";
import HistoryScoin from "../pages/history-scoin/HistoryScoin";
import IsiKuesioner from "../pages/isi-kuesioner/IsiKuesioner";
import Partisipasi from "../pages/partisipasi/Partisipasi";
import Responden from "../pages/responden/Responden";
import UndangKuesioner from "../pages/undang/UndangKuesioner";


export const routes = [
    {path: "/", component: Bursa, title: "Kuesioner - Bursa", exact: true},
    {path: "/buat", component: Buat, title: "Buat Kuis & Panduan"},
    {path: "/daftar-kuesioner", component: DaftarKuisioner, title: "Daftar Kuesioner"},
    {path: "/partisipasi", component: Partisipasi, title: "Partisipasi"},
    {path: "/responden", component: Responden, title: "Responden"},
    {path: "/hasil-kuis", component: HasilKuis, title: "Hasil Kuis", exact: true},
    {path: "/history-scoin", component: HistoryScoin, title: "History Scoin"},
    {path: "/edit/:idKuesioner", component: Edit, title: "Edit Kuesioner"},
    {path: "/undang-kuesioner/:idKuesioner", component: UndangKuesioner, title: "Undang Kuesioner", exact: true},
    {path: "/detail-kuesioner", component: DetailKuesioner, title: "Detail Kuesioner"},
    {path: "/hasil-kuesioner/:idKuesioner", component: HasilKuesioner, title: "Hasil Kuesioner", exact: true},
    {path: "/isi-kuesioner/:idKuesioner", component: IsiKuesioner, title: "Isi Kuesioner", exact: true},
]